module.exports = __webpack_public_path__ + "static/overview-6da0ad3642c0b4af547f3703fdad4f85.svg";